import { render } from "./Btn.vue?vue&type=template&id=92e6871e"
import script from "./Btn.vue?vue&type=script&lang=ts"
export * from "./Btn.vue?vue&type=script&lang=ts"

import "./Btn.vue?vue&type=style&index=0&id=92e6871e&lang=stylus"
script.render = render

export default script